import { combineReducers } from 'redux'

// Reducers
import navigation from './navigation'
import newShare from './newShare'
import viewShare from './viewShare'

const rootReducer = combineReducers({
    navigation,
    newShare,
    viewShare
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/ducks/index.js